export const QUICK_FILTERS_KEY = "quickFilters";
